<template>
  <v-container class="app-filters-row">
    <v-row>
      <v-col class="pa-0 pr-2" cols="3" lg="2">
        <v-row>
          <FinderSelector
            v-model="internalFilters[model_checklist.fields.STATUS]"
            :additional_values="model_checklist.statuses"
            :hide_value="true"
            :return_object="false"
            icon="flag"
            placeholder="Estado"
            text_name="name"
            text_value="id"
          />
        </v-row>
      </v-col>
      <v-col class="pa-0  px-2" cols="4" lg="2">
        <v-row>
          <FinderSelector
            v-model="internalFilters[model_checklist.fields.MASTER_ACCOUNT_CODE]"
            :hide_value="true"
            :icon="$icons.I_MASTER_ACCOUNT"
            :text_name="model_masteraccount.NAME"
            :text_value="model_masteraccount.CODE"
            placeholder="Cuenta raíz"
            url="app-center/masteraccounts"
          />
        </v-row>
      </v-col>
      <v-col v-if="!helpers.nullOrEmpty(internalFilters[model_checklist.fields.MASTER_ACCOUNT_CODE])" class="pa-0  px-2"
             cols="6"
             lg="2">
        <v-row>
          <FinderSelector
            v-model="internalFilters[model_checklist.fields.SUBACCOUNT_CODE]"
            :disabled=" helpers.nullOrEmpty(internalFilters[model_checklist.fields.MASTER_ACCOUNT_CODE])"
            :filters="{[model_subaccount.MASTER_ACCOUNT_CODE]:internalFilters[model_checklist.fields.MASTER_ACCOUNT_CODE]}"
            :hide_value="true"
            :icon="$icons.I_SUBACCOUNT"
            :text_name="model_subaccount.NAME"
            :text_value="model_subaccount.CODE"
            placeholder="Subcuenta"
            url="app-center/subaccounts"
          />
        </v-row>
      </v-col>
      <v-col class="pa-0 px-2" cols="6" lg="2">
        <v-row>
          <FinderSelector
            v-model="internalFilters[model_checklist.fields.PROCESS_CODE]"
            :filters="{[model_process.MASTER_ACCOUNT_CODE]:internalFilters[model_process.MASTER_ACCOUNT_CODE],[model_process.SUB_ACCOUNT_CODE]:internalFilters[model_checklist.fields.SUB_ACCOUNT_CODE]}"
            :hide_value="true"
            :icon="$icons.I_PROCESS"
            :text_name="model_process.NAME"
            :text_value="model_process.CODE"
            placeholder="Proceso"
            url="app-center/processes"
          />
        </v-row>
      </v-col>
      <v-col class="pa-0 px-2" cols="6" lg="2">
        <v-row>
          <FinderSelector
            v-model="internalFilters[model_user.USERNAME]"
            :hide_value="true"
            icon="person"
            placeholder="Usuario"
            text_name="username"
            text_value="username"
            url="app-center/users"
          />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import FinderSelector from '@/components/repository/fields/FinderSelector'
  import helpers from '@/plugins/helpers'
  import model_masteraccount from '@/constants/models/model_masteraccount'
  import model_subaccount from '@/constants/models/model_subaccount'
  import model_user from '@/constants/models/app_center/model_user'
  import model_checklist from '@/constants/models/pkc/model_checklist'
  import model_process from '@/constants/models/model_process'

  export default {
    name: 'PKCChecklistTableFilters',
    computed: {
      model_process() {
        return model_process
      },
      model_checklist() {
        return model_checklist
      }
    },
    components: { FinderSelector },
    props: {
      activeFilters: {
        type: Object,
        required: true
      },
      loading: Boolean
    },
    data() {
      return {
        helpers,
        model_masteraccount,
        model_subaccount,
        model_user,
        internalFilters: null
      }
    },
    created() {
      this.internalFilters = Object.assign({}, this.activeFilters)
    },
    watch: {
      activeFilters(value) {
        this.internalFilters = Object.assign({}, value)
      },
      internalFilters: {
        handler(filters) {
          const cleaned = {}
          Object.keys(filters).forEach(k => {
            if (!helpers.nullOrEmpty(filters[k]) && filters[k] !== 'disabled') {
              cleaned[k] = filters[k]
            }
          })
          this.$emit('changeFilters', cleaned)
        },
        deep: true
      }
    }
  }
</script>